import "./style.css";
import { tns } from "@/node_modules/tiny-slider/src/tiny-slider";
import "@/node_modules/tiny-slider/dist/tiny-slider.css";
export default class RelatedNews {
  static selector = ".related-articles";

  constructor(block) {
    this.block = block;

    this.slides = this.block.querySelectorAll(".article-item");
    this.navContainer = this.block.querySelector(".carousel-dots");
  }

  onReady() {
    // add dots based on number of items
    this.slides.forEach(() => {
      var node = document.createElement("button");
      node.classList.add("carousel-dots__dot");
      this.navContainer.appendChild(node);
    });

    this.dots = this.block.querySelectorAll(".carousel-dots__dot");
    if (this.dots.length > 0) {
      this.dots[0].classList.add("active");
    }

    this.relatedArticlesSlider = tns({
      container: "#articles-slider",
      navContainer: this.navContainer,
      controls: false,
      slideBy: 1,
      items: 1,
      gutter: 20,
      loop: false,
      mouseDrag: true,
      responsive: {
        765: {
          gutter: 28,
        },
        1025: {
          items: 4,
        },
      },
    });
    this.handleListeners();
  }

  handleListeners = () => {
    this.relatedArticlesSlider.events.on("indexChanged", this.handleControls);
  };

  handleControls = (e) => {
    this.dots.forEach((dot, i) => {
      if (i === e.index) {
        dot.classList.add("active");
      } else {
        dot.classList.remove("active");
      }
    });
  };
}
